import React, { useState } from "react";
import classNames from "classnames";

import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import styles from "./style.module.scss";
import JodoRows from "./JodoRows";
import RepresentDialoge from "./RepresentDialoge";


export const TableRows = ({
  rows = [],
  disable,
  representHandler,
  representRow,
  setRepresentRow,
  currentApplicationDetails
}) => {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpand = (index) => {
    setExpandedItems((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return rows.map((row, index) => {
    // Determine if the current row is checked

    return (
      <React.Fragment key={`${row.description}-${index}`}>
        <div
          className={classNames(styles["table-list"])}
        >
          <JodoRows
            row={row}
            isParent={true}
            installment={Number(row?.installmentNumber)}
            currentApplicationDetails={currentApplicationDetails}
          />
          <div>
            {row.installmentBreakUp && (
              <span onClick={() => toggleExpand(index)}>
                {expandedItems[index] ? (
                  <span className="cursor">
                    {" "}
                    <MdKeyboardArrowUp size={26} />
                  </span>
                ) : (
                  <span className="cursor">
                    {" "}
                    <MdKeyboardArrowDown size={26} />
                  </span>
                )}
              </span>
            )}
          </div>
        </div>
        {expandedItems[index] && row.installmentBreakUp && (
          <div className={styles["installment-parent-container"]}>
            {row.installmentBreakUp.map((child, childIndex) => {
              // Determine if the child is checked

              return (
                <div
                  className={classNames(
                    styles["table-list"],
                    styles["instalment-inner-table"]
                  )}
                  style={{ paddingTop: '8px', paddingBottom: '8px' }}
                  key={`JODO -${row.referenceNumber} - ${index}-${childIndex}`}
                >
                  <JodoRows
                    isChildren={true}
                    row={child}
                    installment={`${Number(row?.installmentNumber)}.${childIndex + 1}`}
                    representHandler={representHandler}
                    childIndex={childIndex}
                    currentApplicationDetails={currentApplicationDetails}
                  />
                </div>
              );
            })}
          </div>
        )}

      </React.Fragment>
    );
  });
};
